import React from "react";
import { Dialog } from "@headlessui/react"; 

const Overlay = ({ isOpen }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={() => {}}
      className="fixed z-10 inset-0 overflow-y-auto"
    >
      <div
        className="fixed z-10 inset-0 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <div
            className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
            aria-hidden="true"
          ></div>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>

          <div className="absolute overlay-center">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-b-4 border-white"></div>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default Overlay;
